
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { supabase } from "@/integrations/supabase/client";
import { useToast } from '@/hooks/use-toast';
import { RefreshCw, Mail } from 'lucide-react';

interface SalesMetricsControlsProps {
  isUpdating: boolean;
  updateMessage: string;
  onUpdateMetrics: () => void;
}

export const SalesMetricsControls: React.FC<SalesMetricsControlsProps> = ({
  isUpdating,
  updateMessage,
  onUpdateMetrics
}) => {
  const { toast } = useToast();
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  const handleSendSalesReport = async () => {
    try {
      setIsSendingEmail(true);
      
      const { data, error } = await supabase.functions.invoke('send-sales-metrics', {
        body: { sendToAllUsers: true }
      });

      if (error) {
        throw error;
      }

      toast({
        title: "Success",
        description: "Sales report email sent successfully!",
      });

      console.log('Sales report email sent:', data);
    } catch (error) {
      console.error('Error sending sales report email:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to send sales report email. Please try again.",
      });
    } finally {
      setIsSendingEmail(false);
    }
  };

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="space-x-2">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={onUpdateMetrics} 
          disabled={isUpdating}
        >
          <RefreshCw className={`h-4 w-4 mr-2 ${isUpdating ? 'animate-spin' : ''}`} />
          Refresh Metrics
        </Button>
        
        <Button 
          variant="secondary" 
          size="sm" 
          onClick={handleSendSalesReport}
          disabled={isSendingEmail}
        >
          <Mail className="h-4 w-4 mr-2" />
          {isSendingEmail ? 'Sending...' : 'Email Sales Report'}
        </Button>
      </div>
      
      {updateMessage && <span className="text-sm text-muted-foreground">{updateMessage}</span>}
    </div>
  );
};
